let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let normalizeUsername = require("../../utils/normalizeUsername");

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {
			event_to_save: null
		};
	},
	Radio_setup(){
		return {
			EventRepChanged_show_modal(event, old_eventrep_login){
				let new_event = _.cloneDeep(event);
				let Displaylists = this.props.Displaylists;
				// we need to look up the pd rep in the sitelists
				let old_login = normalizeUsername(_.get(_.indexBy(_.get(Displaylists, ["sitelists", "pd_reps"]), "id"), [old_eventrep_login, "login"]));
				let new_login = normalizeUsername(_.get(_.indexBy(_.get(Displaylists, ["sitelists", "pd_reps"]), "id"), [new_event.pd_rep_id, "login"]));
				new_event.EventTodo = _.map(new_event.EventTodo, function(todo){
					let curr_login = normalizeUsername(todo && todo.assignedto);
					if(todo && todo.status == 1) { // ignore completed todos
							return todo;
					}
					if(old_login !== curr_login) {
						return todo;
					}
					return _.assign({}, todo, {assignedto: new_login});
				});

				if(!_.isEqual(event, new_event)){
					this.setState({event_to_save: new_event});
				}
			}
		};
	},
	__doIt: esUtils.wrapPreventDefault(function(){
		let {event_to_save} = this.state;

		radio("save_Event").broadcast(event_to_save);
		this.setState({event_to_save: null});
	}),
	__close: esUtils.wrapPreventDefault(function(){
		this.setState({event_to_save: null});
	}),
	render(){
		let {event_to_save} = this.state;
		if(!event_to_save){
			return dd.div();
		}

		return Modal({
				title: "The Event Rep was changed.",
				buttons: [
					{
						name: "No thanks",
						onClick: this.__close,
						className: "btn btn-default"
					},
					{
						name: "Yes, please",
						onClick: this.__doIt,
						className: "btn btn-primary"
					}
				],
				onClose: this.__close
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({
						className: "fa fa-user text-muted",
						style: {fontSize: 100}
					})
				),
				dd.div({className: "col-sm-9"},
					dd.p({className: "preserve-whitespace"},
						"The Event Rep was changed.\n\nDo you want to change applicable action items to the new person?"
					)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/EventRepChanged.js